import type { ElectricalSlots } from "building-types/electrical/electricalSlots";
import { LoadTypeSlot } from "building-types/electrical/electricalSlots";
import type { LoadType } from "building-types/electrical/electricalTypesEnum";

export function loadTypeFromSlots(loadTypeSlot: LoadTypeSlot | undefined, slots: ElectricalSlots): LoadType {
  const { loads } = slots;

  if (loadTypeSlot === undefined) {
    return slots.loads.primaryLight;
  }

  switch (loadTypeSlot) {
    case LoadTypeSlot.PRIMARY_LIGHT:
      return loads.primaryLight;
    case LoadTypeSlot.SECONDARY_LIGHT:
      return loads.secondaryLight !== undefined ? loads.secondaryLight : loads.primaryLight;
    case LoadTypeSlot.TERTIARY_LIGHT:
      if (loads.tertiaryLight !== undefined) {
        return loads.tertiaryLight;
      } else if (loads.secondaryLight !== undefined) {
        return loads.secondaryLight;
      }
      return loads.primaryLight;
    case LoadTypeSlot.QUATERNARY_LIGHT:
      if (loads.quaternaryLight !== undefined) {
        return loads.quaternaryLight;
      } else if (loads.tertiaryLight !== undefined) {
        return loads.tertiaryLight;
      } else if (loads.secondaryLight !== undefined) {
        return loads.secondaryLight;
      }
      return loads.primaryLight;

    case LoadTypeSlot.OUTLET:
      return loads.outlet;
    case LoadTypeSlot.OUTLET_GFCI:
      return loads.outletGFCI;
    case LoadTypeSlot.OUTLET_GFCI_WP:
      return loads.outletGFCIwaterProof;
    case LoadTypeSlot.OUTLET_FLOOR:
      return loads.outletFloor;
    case LoadTypeSlot.CABLE_OUTLET:
      return loads.cableOutlet;
    case LoadTypeSlot.RECESSED_CEILING_LIGHT:
      return loads.recessedCeilingLight;
    case LoadTypeSlot.PENDANT_CEILING_LIGHT:
      return loads.pendantCeilingLight;
    case LoadTypeSlot.KEYLESS_CEILING_LIGHT:
      return loads.keylessCeilingLight;
    case LoadTypeSlot.FLOURESCENT_CEILING_LIGHT:
      return loads.flourescentCeilingLight;
    case LoadTypeSlot.TRACK_CEILING_LIGHT:
      return loads.trackCeilingLight;
    case LoadTypeSlot.MOUNTED_WALL_LIGHT:
      return loads.mountedWallLight;
    case LoadTypeSlot.FLOOD_LIGHT:
      return loads.floodLight;
    case LoadTypeSlot.FAN_CEILING:
      return loads.fanCeiling;
    case LoadTypeSlot.SMOKE_DETECTOR:
      return loads.smokeDetector;
    case LoadTypeSlot.CARBON_MONOXIDE_DETECTOR:
      return loads.carbonMonoxideDetector;
    case LoadTypeSlot.THERMOSTAT:
      return loads.thermostat;
    case LoadTypeSlot.BATH_FAN:
      return loads.bathFan;
    case LoadTypeSlot.HOSE_BIB:
      return loads.hoseBib;
    case LoadTypeSlot.OUTLET_240V:
      return loads.outlet240V;
    case LoadTypeSlot.OUTLET_220V:
      return loads.outlet220V;
    case LoadTypeSlot.OUTLET_CAT5:
      return loads.outletCAT5;
    case LoadTypeSlot.OUTLET_HDMI:
      return loads.outletHDMI;
    case LoadTypeSlot.DOORBELL_CHIME:
      return loads.doorbellChime;
    case LoadTypeSlot.GARAGE_DOOR_OPENER:
      return loads.garageDoorOpener;
    case LoadTypeSlot.DISH_DISPOSAL:
      return loads.dishDisposal;
  }
}
